import { render, staticRenderFns } from "./FootballPage.vue?vue&type=template&id=62b3d8f5&scoped=true&"
import script from "./FootballPage.vue?vue&type=script&lang=js&"
export * from "./FootballPage.vue?vue&type=script&lang=js&"
import style0 from "./FootballPage.vue?vue&type=style&index=0&id=62b3d8f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3d8f5",
  null
  
)

export default component.exports